import { Sparkles } from "lucide-react";

const UserValue = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Diseñado por dentistas, para dentistas
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Sabemos exactamente lo que necesitas porque nosotros también lo
            vivimos
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl border border-slate-200 shadow-lg">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center text-white text-2xl mb-4">
              💡
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">
              "La tecnología debería servir a la salud, no complicarla"
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4">
              Somos un equipo de tech que vio cómo consultorios siguen usando
              papel en pleno 2025. Creemos que herramientas digitales simples
              pueden hacer la salud más accesible para todos.
            </p>
            <div className="text-sm text-slate-500">
              — Equipo Fundador, OdontoStark
            </div>
          </div>

          <div className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl border border-slate-200 shadow-lg">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center text-white text-2xl mb-4">
              🎯
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">
              En Beta Testing con consultorios reales
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4">
              Estamos mejorando cada día con feedback directo de dentistas como
              vos. Tu opinión cuenta.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold">
              <Sparkles className="w-4 h-4" />
              Únete al desarrollo
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserValue;
